// Which of the three feedback sections is available, and which is waiting on
// the one above it.
//
// Locked-ness is derived on every render and never stored. Storing it produces
// the bug where re-running Diagnostics leaves How to Improve unlocked against
// output that no longer exists.

export const TARA_FEEDBACK_STAGES = ['diagnostic', 'enrichment', 'performance'];

export const TARA_STAGE_TITLES = {
  diagnostic: 'Diagnostics',
  enrichment: 'How to Improve',
  performance: 'Performance Report',
};

// A stage that could not read its input tells us nothing about the essay, so
// nothing below it can run. A stage that ran on thin evidence did produce a
// result, and the stages below it explain why it was thin, so they stay open.
const BLOCKS_WHAT_FOLLOWS = 'INPUT_RESOLUTION_FAILED';

function phaseFor(entry) {
  if (!entry) return 'idle';
  if (entry.phase === 'running' || entry.status === 'in_progress') return 'running';
  if (entry.status === 'failed' || entry.status === 'invalid_output') return 'error';
  if (entry.phase === 'error') return 'error';
  if (entry.status === 'succeeded' && entry.data) return 'ready';
  if (entry.phase === 'ready' && entry.data) return 'ready';
  return 'idle';
}

export function taraFeedbackGating(stages = {}) {
  const out = {};
  let blocked = false;
  let blockedBy = null;

  TARA_FEEDBACK_STAGES.forEach((stage, index) => {
    const entry = stages[stage];
    const phase = phaseFor(entry);

    if (blocked) {
      out[stage] = {
        phase: 'locked',
        lockReason: `Available once ${TARA_STAGE_TITLES[blockedBy]} has run.`,
      };
      return;
    }

    out[stage] = { phase, lockReason: null };

    const previous = TARA_FEEDBACK_STAGES[index];
    if (phase !== 'ready') {
      blocked = true;
      blockedBy = previous;
      return;
    }
    if (entry && entry.status_label === BLOCKS_WHAT_FOLLOWS) {
      blocked = true;
      blockedBy = previous;
    }
  });

  return out;
}

export function taraNextRunnableStage(stages = {}) {
  const gating = taraFeedbackGating(stages);
  return TARA_FEEDBACK_STAGES.find((s) => gating[s].phase === 'idle') || null;
}
